import { singleton } from "tsyringe";
import {
  ConsentProviderInterface,
  ConsentResolvedCallback,
} from "@identity/services";

@singleton()
export class StaticConsentStrategy implements ConsentProviderInterface {
  subscribe(callback: ConsentResolvedCallback): void {
    callback({
      gdprConsent: true,
      geoRequiresSignal: false,
      geoRequiresConsent: false,
      ccpaSignal: false,
    });
  }
}
